"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNKNOWN_ERROR = exports.MULTI_PRODUCT_ACTION_NAME = exports.MULTI_PRODUCT_ERROR_PREFIX = exports.getDefaultHeight = exports.isMobile = exports.isIframe = exports.isClient = exports.isServer = void 0;
exports.isServer = typeof window === 'undefined';
exports.isClient = typeof window !== 'undefined';
exports.isIframe = exports.isClient && window !== window.parent;
exports.isMobile = typeof window !== 'undefined' && window.innerWidth < 768; // basic detect
var getDefaultHeight = function (productType, step) {
    var platform = exports.isMobile ? 'mobile' : 'desktop';
    switch (productType) {
        case 'INSURANCE':
            return {
                select: {
                    desktop: 857,
                    mobile: 1045,
                },
                checkout: {
                    desktop: 200,
                    mobile: 180,
                },
                confirmation: {
                    desktop: 80,
                    mobile: 80,
                },
            }[step][platform];
        default:
            return {
                select: {
                    desktop: 0,
                    mobile: 0,
                },
                checkout: {
                    desktop: 0,
                    mobile: 0,
                },
                confirmation: {
                    desktop: 0,
                    mobile: 0,
                },
            }[step][platform];
    }
};
exports.getDefaultHeight = getDefaultHeight;
exports.MULTI_PRODUCT_ERROR_PREFIX = 'MultiProductError:';
exports.MULTI_PRODUCT_ACTION_NAME = 'multi_product';
exports.UNKNOWN_ERROR = 'Unknown error';
